import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { HelpCircle } from 'lucide-react';

export const FAQSection = ({ faqs, accentColor = '#38B6FF', title = 'Frequently Asked Questions', subtitle = 'Find answers to common questions', sectionId = 'faq' }) => {
  return (
    <>
      {/* JSON-LD FAQ Schema for SEO */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map(faq => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }).replace(/</g, '\\u003c'),
        }}
      />

      <section className="py-20 md:py-28 bg-white" id={sectionId} data-testid={`faq-section-${sectionId}`}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <div
              className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-sm font-medium mb-5"
              style={{ backgroundColor: `${accentColor}15`, color: accentColor }}
            >
              <HelpCircle className="w-4 h-4" />
              FAQ
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 font-['Outfit'] tracking-tight mb-4">
              {title}
            </h2>
            <p className="text-base text-slate-500 max-w-xl mx-auto">{subtitle}</p>
          </div>

          <Accordion type="single" collapsible className="w-full space-y-3">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border border-slate-200 rounded-xl px-6 data-[state=open]:border-slate-300 data-[state=open]:shadow-sm transition-all duration-200"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-base font-semibold text-slate-800 hover:no-underline py-5 gap-4 font-['Outfit']">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed text-sm pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </>
  );
};
